import { render, staticRenderFns } from "./subheader.vue?vue&type=template&id=30f6fbcf&scoped=true&"
import script from "./subheader.vue?vue&type=script&lang=js&"
export * from "./subheader.vue?vue&type=script&lang=js&"
import style0 from "./subheader.vue?vue&type=style&index=0&id=30f6fbcf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f6fbcf",
  null
  
)

export default component.exports